import React from "react";
import { useUnits } from "../contexts/ResultsContext";

export default function Unit({ unit_id, onChange }) {
  const compatibleUnits = useUnits(unit_id);
  const handleChange = e => onChange(e.target.value);

  return (
    <select value={unit_id} onChange={handleChange}>
      {compatibleUnits.map(unit => (
        <option key={unit.id} value={unit.id}>
          {unit.text}
        </option>
      ))}
    </select>
  );
}
